import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Configuration de la persistance des sessions
    persistSession: true,
    // Détection automatique du type de stockage
    storage: window?.localStorage,
    // Rafraîchissement automatique des tokens
    autoRefreshToken: true,
    // Détection des changements de focus pour vérifier la session
    detectSessionInUrl: true
  }
})

// Export des variables pour l'API REST
export { supabaseUrl, supabaseAnonKey }
